module.exports = __webpack_public_path__ + "static/media/arduino.cacd9bc9.svg";